module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.667ee3d3.png";